/*!

=========================================================
* Argon Dashboard PRO React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import React from "react";
// react library for routing
// reactstrap components
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    Col,
    Collapse,
    Container,
    Form,
    FormGroup,
    ListGroup,
    ListGroupItem,
    Modal,
    Nav,
    Navbar,
    NavbarBrand,
    NavItem,
    NavLink,
    Row
} from 'reactstrap';
// core components
import ContentService from "../services/xgContentService";
import _ from "lodash";
import CompaniesCarousel from "./CompaniesCarousel";
import {countries} from "../util/countries";
import FormReactSelect from "../components/common/form/FormReactSelect";
import {services} from "../util/services";
import NotificationAlert from "react-notification-alert";
import {deliveryPeriods} from "../util/deliveryPeriods";
import UtilService from "../services/utilService";
import Login from "./pages/auth/Login";
import FormInput from "../components/common/form/FormInput";
import ContactUsService from "../services/contactUsService";
import Loader from "./Loader";
import {isMobile} from "react-device-detect";
import AppNavBar from "./AppNavBar";
import moment from "moment";
import formatFrontendDate from "./pages/util/formatFrontendDate";
import isTrainingSession from "./pages/util/isTrainingSession";

class Index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            collapseSearchServices: false,
            collapseSearchArticles: false,
            completeContentList: [],
            selectKey: UtilService.uuidv4(),
            loginModal: false,
            contactUsModal: false,
            searchList: [],
            services: [],
            country: "",
            deliveryPeriod: "",
            name: "",
            email: "",
            contactNumber:"",
            loading: false
        };
        this.filterByContentType = this.filterByContentType.bind(this);
        this.handleCountrySelectChange = this.handleCountrySelectChange.bind(this);
        this.submitServices = this.submitServices.bind(this);
        this.notify = this.notify.bind(this);
        this.renderLogin = this.renderLogin.bind(this);
        this.onChange = this.onChange.bind(this);
        this.handleDeliveryPeriodChange = this.handleDeliveryPeriodChange.bind(this);
    }

    componentDidMount() {
        this.toggleSearchServices();
        ContentService.list().then((response) => {
            const paidOrTrainingContent = response.filter(content => content.isPaidContent || isTrainingSession(content));
            const paidOrTrainingContentSet = new Set(paidOrTrainingContent);
            const freeContentList = response.filter(content => !paidOrTrainingContentSet.has(content));
            this.setState({completeContentList: freeContentList});
            this.setState({audioVideo: this.filterByContentType(freeContentList, false)});
            this.setState({text: this.filterByContentType(freeContentList, true)});

        });
    }

    handleChange(event) {
        this.setState({[event.target.name]: event.target.value});
    }

    handleCountrySelectChange(valueObj) {
        if (_.isNull(valueObj)) {
            this.setState({selectedCountry: {}, country: ""});
        } else {
            this.setState({selectedCountry: valueObj, country: valueObj.key});
        }
    }

    handleDeliveryPeriodChange(valueObj) {
        if (_.isNull(valueObj)) {
            this.setState({selectedDeliveryPeriod: {}, deliveryPeriod: ""});
        } else {
            this.setState({selectedDeliveryPeriod: valueObj, deliveryPeriod: valueObj.key});
        }
    }

    handleServicesChange = (valueObj, event) => {
        if (_.isNull(valueObj)) {
            this.setState({services: []});
        } else {
            this.setState({services: valueObj});
            const keys = _.map(valueObj, "key")
            this.setState({services: keys});
        }
    };

    toggleModal = state => {
        this.setState({
            [state]: !this.state[state]
        });
    };

    submitServices(event) {
        if (this.state.services.length === 0 || this.state.country === "" || this.state.deliveryPeriod === "") {
            this.notify("error", "Error", "All fields are mandatory!")
        } else {
            this.toggleModal("contactUsModal");
        }
    }

    icon = (item) => {
        let icon;
        switch (item.contentType) {
            case 'TEXT':
                icon = "fa fa-file-alt";
                break;
            case 'VIDEO':
                icon = "fa fa-video";
                break;
            case 'AUDIO':
                icon = "fa fa-headphones";
                break;
            default:
                icon = "fa fa-file-alt"; // Default icon if type is unknown
        }
        return icon;
    }


    filterByContentType = (data, textType) => {
        let filteredData = [];
        if(textType === true) {
            // Filter by text/article
           filteredData  = _.filter(data, {contentType: "TEXT"});
        } else {
            filteredData  = _.filter(data, article => article.contentType !== "TEXT");
        }
        // Sort by dateCreated in descending order (latest first)
        const sortedData = _.orderBy(filteredData, ['dateCreated'], ['desc']);

        // Pick the first 5 elements
        return sortedData.slice(0, 3);
    };

    toggleSearchServices = () => {
        this.setState({
            collapseSearchServices: !this.state.collapseSearchServices, collapseSearchArticles: false // Close the articles section when services is toggled
        });
    }

    toggleSearchArticles = (event) => {
        event.preventDefault();
        this.props.history.push("/knowledgeCentre");
    }
    toggleSearchReviews = (event) => {
        event.preventDefault();
        this.props.history.push("/xareview");
    }

    displaySearchArticles = () => {
        return this.state.searchList.length === 0 ? "Display Search Articles" : <></>
    }

    onSearchInputChange = (event) => {
        let term = event.target.value;
        this.setState({term: event.target.value})
    }

    displayArticles = () => {
        if (this.state.completeContentList) {
            return (<>
                <Container className="mt-6" fluid>
                    <hr/>
                    <Row className="justify-content-center">
                        <h1 className="text-center" style={{marginBottom: "20px", marginTop: "20px"}}>Recent
                            Posts</h1>
                    </Row>
                    <Row>
                        <Col xl="6">
                            <Card>
                                <CardHeader>
                                    <h5 className="h3 mb-0">ARTICLES</h5>
                                </CardHeader>

                                <CardBody className="p-0">
                                    <ListGroup data-toggle="checklist" flush>
                                        {this.state?.text?.map((article, index) => (<ListGroupItem
                                            key={index} // Add a key prop for each item in the list
                                            className="checklist-entry flex-column align-items-start py-4 px-4"
                                        >
                                            <div className="checklist-item checklist-item-gray">
                                                <div className="checklist-gray-dark">
                                                    <h5 className="checklist-title mb-0"
                                                        style={{cursor: "pointer"}}
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            this.props.history.push(`/blog/${article.uniqueId}`);
                                                        }}
                                                    >
                                                        {article.title || 'Meeting with teachers.'} {/* Use article title */}
                                                    </h5>
                                                    <small>{formatFrontendDate(article.dateCreated) || '3:30 PM'}</small> {/* Use article time if available */}
                                                </div>

                                                <span className={this.icon(article)}
                                                      style={{cursor: "pointer"}}
                                                      onClick={(e) => {
                                                          e.preventDefault();
                                                          this.props.history.push(`/blog/${article.uniqueId}`);
                                                      }}/>

                                            </div>
                                        </ListGroupItem>))}


                                    </ListGroup>

                                </CardBody>
                            </Card>
                        </Col>
                        <Col xl="6">
                            <Card>
                                <CardHeader>
                                    <h5 className="h3 mb-0">AUDIO/VIDEO</h5>
                                </CardHeader>

                                <CardBody className="p-0">
                                    <ListGroup data-toggle="checklist" flush>
                                        {this.state?.audioVideo?.map((article, index) => (<ListGroupItem
                                            key={index} // Add a key prop for each item in the list
                                            className="checklist-entry flex-column align-items-start py-4 px-4"
                                        >
                                            <div className="checklist-item checklist-item-info">
                                                <div className="checklist-info">
                                                    <h5 className="checklist-title mb-0"
                                                        style={{cursor: "pointer"}}
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            this.props.history.push(`/blog/${article.uniqueId}`);
                                                        }}
                                                    >
                                                        {article.title || 'Meeting with teachers.'} {/* Use article title */}
                                                    </h5>
                                                    <small>{formatFrontendDate(article.dateCreated) || '3:30 PM'}</small> {/* Use article time if available */}
                                                </div>
                                                <span className={this.icon(article)}
                                                      style={{cursor: "pointer"}}
                                                      onClick={(e) => {
                                                          e.preventDefault();
                                                          this.props.history.push(`/blog/${article.uniqueId}`);
                                                      }}/>

                                            </div>
                                        </ListGroupItem>))}

                                    </ListGroup>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Row className="justify-content-center">
                        <Button color="default" outline
                                onClick={(event) => {
                                    event.preventDefault();
                                    this.props.history.push("/knowledgeCentre");
                                }}
                        >See all content</Button>
                    </Row>
                </Container>
            </>);
        }
    }

    renderLogin() {
        return (<>
            <Button color="default" className="mb-3" outline
                    onClick={(event) => {
                        event.preventDefault();
                        this.props.history.push("/auth/login");
                    }}
            >
                Login
            </Button>
        </>);
    }

    notify = (type, title, message) => {
        let options = {
            place: "tc", message: (<div className="alert-text">
          <span className="alert-title" data-notify="title">
            {title}
          </span>
                <span data-notify="message">{message}</span>
            </div>), type: type, icon: "ni ni-bell-55", autoDismiss: 5,
        };
        this.refs.notificationAlert.notificationAlert(options);
    };

    onChange(event) {
        this.setState({[event.target.name]: event.target.value});
    }

    submitQuery = (event) => {
        this.setState({loading: true});
        if (this.state.services.length === 0 || this.state.country === "" || this.state.deliveryPeriod === "" ||
            this.state.name === "" || this.state.email === "" || this.state.contactNumber === "") {
            this.notify("error", "Error", "All fields are mandatory!")
            this.setState({loading: false});
        } else {
            const data = {
                services: this.state.services,
                country: this.state.country,
                deliveryPeriod: this.state.deliveryPeriod,
                name: this.state.name,
                email: this.state.email,
                contactNumber: this.state.contactNumber,
            }
            ContactUsService.contactUs(data).then(response => {
                this.toggleModal("contactUsModal")
                this.notify("success", "Query Submitted", "Thank you for sharing your query with us. We will shortly reply you back.")
                this.setState({
                    services: [],
                    country: "",
                    deliveryPeriod: "",
                    name: "",
                    email: "",
                    contactNumber:"",
                    selectedCountry: {},
                    selectedDeliveryPeriod: {},
                    selectKey: UtilService.uuidv4()
                })
            }).catch(response => {
                this.notify("danger", "Error", "Uh-oh seems like we are facing some technical glitch at our end!")
            })
            this.setState({loading: false});
        }

    }


    render() {
        let completeContentList = this.state.completeContentList;
        return (<div>
            {/* Navbar */}
            <div>
                {this.state.loading ? (<Loader/>) : ("")}
            </div>
            <div className="rna-wrapper">
                <NotificationAlert ref="notificationAlert"/>
            </div>
            {/*Nav Bar*/}
            <AppNavBar loginModalToggle={this.toggleModal}/>

            {/* Hero Banner */}
            <div className="hero-banner">
                <Container fluid>
                    <Row>
                        <Col>
                            <div className="hero-banner-content">
                                <p style={{textAlign: "justify"}}>A Collaborative Approach to</p>
                                <h1 style={{textAlign: "justify", color: "white"}}>International Expansion</h1>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
            <br/>
            <br/>
            <br/>
            {/* Collapsible Sections */}
            <Container className={"mt-10"}
                       style={{
                           border: "2px solid #4E5F7A", padding: "1.5rem", borderRadius: "2px", marginTop: "2.5rem", // Adjust to divide the buttons in half
                           position: "relative", zIndex: "1",
                       }}>
                <Col className="text-center" style={{marginTop: "-4rem"}}>
                    <Button color="default" className="mb-3"
                            style={{
                                width: "30%",
                                fontSize: "1.5rem",
                                padding: "1.5%"
                            }}>
                        {isMobile ? "Services" : "Services"}
                    </Button>
                    {/* Search Articles */}
                    <Button color="white" onClick={this.toggleSearchArticles} className="mb-3"
                            style={{
                                width: "30%",
                                fontSize: "1.5rem",
                                padding: "1.5%",
                                marginLeft: "-0.5rem"
                            }}>
                        {isMobile ? "Knowledge" : "Knowledge"}
                    </Button>
                    {/*Xare View*/}
                    <Button color="white" className="mb-3" onClick={this.toggleSearchReviews}
                            style={{
                                width: "30%",
                                fontSize: "1.5rem",
                                padding: "1.5%",
                                marginLeft: "-0.4rem"
                            }}>
                        {isMobile ? "Reviews" : "Reviews"}
                    </Button>
                </Col>
                <Collapse isOpen={this.state.collapseSearchServices}>
                    <Form>
                        <Row form>
                            <Col md={12}>
                                <FormGroup>
                                    <FormReactSelect
                                        selectKey={this.state.selectKey}
                                        isMulti={true}
                                        className="form-control-label"
                                        isSearchable={true}
                                        label="Select Services"
                                        name={"services"}
                                        onChange={this.handleServicesChange}
                                        optionValue={"value"}
                                        defaultValue={this.state.selectedServices}
                                        optionList={services}
                                        optionLabel={"key"}
                                        placeHolder="Select Services"
                                        errorMsg={this.state?.errorObj?.country || ""}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row form>
                            <Col md={6}>
                                <FormGroup>
                                    <FormReactSelect
                                        selectKey={this.state.selectKey}
                                        isMulti={false}
                                        className="form-control-label"
                                        isSearchable={true}
                                        label="Select Target Country/Market"
                                        name={"country"}
                                        onChange={this.handleCountrySelectChange}
                                        optionValue={"value"}
                                        defaultValue={this.state.selectedCountry}
                                        optionList={countries}
                                        optionLabel={"key"}
                                        placeHolder="Select Target Country/ Market"
                                        errorMsg={this.state?.errorObj?.country || ""}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <FormReactSelect
                                        selectKey={this.state.selectKey}
                                        isMulti={false}
                                        className="form-control-label"
                                        isSearchable={true}
                                        label="Delivery Period"
                                        name={"deliveryPeriod"}
                                        onChange={this.handleDeliveryPeriodChange}
                                        optionValue={"value"}
                                        defaultValue={this.state.selectedDeliveryPeriod}
                                        optionList={deliveryPeriods}
                                        optionLabel={"key"}
                                        placeHolder="Select Delivery Period"
                                        errorMsg={this.state?.errorObj?.deliveryPeriod || ""}
                                    />
                                </FormGroup>
                            </Col>

                        </Row>

                        <div className="text-center">
                            <Button color="default" outline type="button"
                                    onClick={this.submitServices}>Submit</Button>
                        </div>
                    </Form>
                </Collapse>


            </Container>


            {this.displayArticles()}
            <CompaniesCarousel/>

            <Modal
                // size={"lg"}
                className="modal-dialog-centered"
                isOpen={this.state.loginModal}
                toggle={() => this.toggleModal("loginModal")}
            >
                <Login/>
            </Modal>

            <Modal
                className="modal-dialog-centered"
                isOpen={this.state.contactUsModal}
                toggle={() => this.toggleModal("contactUsModal")}
            >
                <div className="modal-header">
                    <h5 className="modal-title" id="contactUsModalLabel">
                        One final Step! Please provide us your contact details to reach back to you.
                    </h5>
                    <button
                        aria-label="Close"
                        className="close"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => this.toggleModal("contactUsModal")}
                    >
                        <span aria-hidden={true}>×</span>
                    </button>
                </div>
                <div className="modal-body">
                    <Row>
                        <Col md="12">
                            <FormInput
                                name="name"
                                className="form-control-label"
                                id="name"
                                placeholder="Name"
                                type="text"
                                onChange={this.onChange}
                                label="Name"
                                value={this.state.name || ""}
                                // errorMsg={this.props.errorObj.firstName || ""}
                            />
                        </Col>
                        <Col md="12">
                            <FormInput
                                name="email"
                                className="form-control-label"
                                id="email"
                                placeholder="Email address"
                                type="email"
                                onChange={this.onChange}
                                label="Email Address"
                                value={this.state.email || ""}
                                // errorMsg={this.props.errorObj.middleName || ""}
                            />
                        </Col>
                        <Col md="12">
                            <FormInput
                                name="contactNumber"
                                className="form-control-label"
                                id="email"
                                placeholder="Contact Number"
                                type="text"
                                onChange={this.onChange}
                                label="Contact Number"
                                value={this.state.contactNumber || ""}
                                // errorMsg={this.props.errorObj.middleName || ""}
                            />
                        </Col>
                    </Row>
                </div>
                <div className="modal-footer">
                    <Button color="default" type="button" outline onClick={this.submitQuery}>
                        Submit Query
                    </Button>
                </div>
            </Modal>

            <footer className="py-5" id="footer-main">
                <Container>
                    <Row className="align-items-center justify-content-xl-between">
                        <Col xl="6">
                            <div className="copyright text-center text-xl-left text-muted">
                                © {new Date().getFullYear()}{" "}
                                <a
                                    className="font-weight-bold ml-1"
                                    href="https://sekim-international.com/"
                                    target="_blank"
                                >
                                    Sekim International
                                </a>
                            </div>
                        </Col>
                        <Col xl="6">
                            <Nav className="nav-footer justify-content-center justify-content-xl-end">
                                <NavItem>
                                    <NavLink
                                        href="https://xaregrowth.com"
                                        target="_blank"
                                    >
                                        XareGrowth
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        href=""
                                        target="_blank"
                                        onClick={(event) => {
                                            event.preventDefault()
                                            this.props.history.push("/aboutUs")
                                        }}
                                    >
                                        About Us
                                    </NavLink>
                                </NavItem>
                            </Nav>
                        </Col>
                    </Row>
                </Container>
            </footer>
        </div>);
    }
}

export default Index;
